import ButtonsStep from "./buttons-step";

import image1 from '../assets/folder.svg';
import image1hover from '../assets/folder-hover.svg';
import image2 from '../assets/payroll.svg';
import image2hover from '../assets/payroll-hover.svg';
import image3 from '../assets/money-talk.svg';
import image3hover from '../assets/money-talk-hover.svg';
import image4 from '../assets/help.svg';
import image4hover from '../assets/help-hover.svg';
import image5 from '../assets/payroll.svg';
import image5hover from '../assets/payroll-hover.svg';
import image6 from '../assets/revenue.svg';
import image6hover from '../assets/revenue-hover.svg';
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { UTM_CAMPAIGN, UTM_SOURCE } from "../constants/ActionTypes";
import Cookies from "universal-cookie";
import { Button } from "react-bootstrap";

function Step1() {
    const cookies = new Cookies();
    const [searchParams, setSearchParams] = useSearchParams();
    const utmSource = searchParams.get("utm_source") ? searchParams.get("utm_source") : cookies.get('utm_source');
    const utmCampaign = searchParams.get("utm_campaign") ? searchParams.get("utm_campaign") : cookies.get('utm_campaign');
    const dispatch = useDispatch();

    const date = new Date();
    date.setDate(date.getDate() + 15);

    if (searchParams.get("utm_source")) {
        cookies.set("utm_source", searchParams.get("utm_source"), { path: '/', expires: date });
    }
    if (searchParams.get("utm_campaign")) {
        cookies.set("utm_campaign", searchParams.get("utm_campaign"), { path: '/', expires: date });
    }

    useEffect(() => {
        dispatch({
            type: UTM_SOURCE,
            utmSource: utmSource
        });
        dispatch({
            type: UTM_CAMPAIGN,
            utmCampaign: utmCampaign
        });
    }, []);

    const stepTitle = `Which services are you interested in?`;

    const stepElements = [
        {
            "text": "Accounting &amp; bookkeeping",
            "image": image1,
            "imageHover": image1hover,
            "value": 1,
            "noNextStep": true
        },
        {
            "text": "Payroll &amp; compliance",
            "image": image2,
            "imageHover": image2hover,
            "value": 2,
            "noNextStep": true
        },
        {
            "text": "CFO &amp; financial advisory",
            "image": image3,
            "imageHover": image3hover,
            "value": 3,
            "noNextStep": true
        },
        {
            "text": "QuickBooks support",
            "image": image4,
            "imageHover": image4hover,
            "value": 4,
            "noNextStep": true
        },
        {
            "text": "Taxes &amp; year-end close",
            "image": image5,
            "imageHover": image5hover,
            "value": 5,
            "noNextStep": true
        },
        {
            "text": "Financial reporting &amp; budgeting",
            "image": image6,
            "imageHover": image6hover,
            "value": 6,
            "noNextStep": true
        },
    ];

    return (
        <>
            <h3 className='h2 fw-normal mb-5 text-center'>{stepTitle}</h3>
            <ButtonsStep stepElements={stepElements} stepTitle={stepTitle} nextButton={true}></ButtonsStep>
        </>
    );
}

export default Step1;